// @flow

// Effect Managers
import { fork } from 'redux-saga/effects'

// Sagas
import watchOrderTestsOperations from './operations'
import { watchOperations } from 'hfty-operator-order-tests'

// Selectors
import orderTestsOperation$ from '../selectors/orderTestsOperation'

export default function *main (): Generator<*, *, *> {
  yield fork(watchOrderTestsOperations)
  yield fork(watchOperations, { orderTestsOperation$ })
}
